export const HEADER = "48px";
/* The football web app's rail: 248px open, 56px collapsed. */
export const SIDEBAR = "248px";
export const SIDEBAR_COLLAPSED = "56px";
